exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mp-dashboard-selector {\n  bottom: 0;\n  left: 0;\n  margin-top: 4px;\n  position: absolute;\n  top: 32px;\n}\nmp-dashboard-selector.align-right {\n  left: unset;\n  right: 320px;\n}\n", ""]);

// exports
